export default __webpack_public_path__ + "static/media/routinely_circular_logo.17b454b4.png";